import React from "react";
import { Globe, ChevronDown } from "lucide-react";
import { LANGUAGES, useI18n } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export function LanguageSwitcher({ compact }) {
  const { lang, setLang } = useI18n();
  const { user, setUser } = useAuth();

  const handleChange = (code) => {
    setLang(code);
    if (user) {
      api.put("/auth/language", { language: code })
        .then(({ data }) => setUser(data))
        .catch(() => { /* non-blocking */ });
    }
  };

  return (
    <div className="relative inline-flex items-center">
      <Globe size={16} className="absolute left-2.5 text-white/60 pointer-events-none z-10" />
      <select
        data-testid="language-switcher"
        value={lang}
        onChange={(e) => handleChange(e.target.value)}
        className={`appearance-none bg-[#111111] border border-white/10 rounded-[12px] text-white text-sm py-2 truncate focus:border-[#007BFF] outline-none cursor-pointer hover:border-white/25 transition-colors ${compact ? "pl-7 pr-5 max-w-[3.5rem] sm:pl-8 sm:pr-7 sm:max-w-[9.5rem]" : "pl-8 pr-7 max-w-[9.5rem]"}`}
        aria-label="Language"
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code} className="bg-[#111111]">
            {l.flag} {l.label}
          </option>
        ))}
      </select>
      <ChevronDown size={15} className="absolute right-2 text-white/50 pointer-events-none" />
    </div>
  );
}
